import "firebase/auth";
import firebase from "firebase/app";
import { firebaseConfig } from "@/config";

// Firebase app initialisaton
const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp;
